<template>
  <!-- 为 ECharts 准备一个定义了宽高的 DOM -->
  <div ref="chart" style="width: 100%;"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "lineChart",
  data() {
    return {};
  },
  mounted() {
    // this.initChart();
  },
  methods: {
    initChart(memberRegist) {
      // 指定图表的配置项和数据
      const fontColor = "#aaa";
      const color = [
        "#0090FF",
        "#FFC005",
        "#36CE9E",
        "#FF515A",
        "#8B5CFF",
        "#00CA69"
      ];
      const hexToRgba = (hex, opacity) => {
        let rgbaColor = "";
        const reg = /^#[\da-f]{6}$/i;
        if (reg.test(hex)) {
          rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
            "0x" + hex.slice(3, 5)
          )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
        }
        return rgbaColor;
      };
      const lineStyle = index => {
        return {
          normal: {
            color: color[index],
            shadowColor: hexToRgba(color[index], 0.5),
            shadowBlur: 3,
            shadowOffsetY: 8
          }
        };
      };
      const areaStyle = index => {
        return {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: hexToRgba(color[index], 0.3)
              },
              {
                offset: 1,
                color: hexToRgba(color[index], 0.1)
              }
            ]),
            shadowColor: hexToRgba(color[index], 0.1),
            shadowBlur: 10
          }
        };
      };
      const myChart = echarts.init(this.$refs.chart);
      console.log("====myChart", myChart);
      const option = {
        title: {
          text: "用户注册分布图",
          left: "center",
          textStyle: {
            // color: fontColor,
            align: "center"
          }
        },
        grid: {
          left: "20",
          right: "20",
          bottom: "10",
          top: "80",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          },
          extraCssText:
            "font-size:14px;line-height:24px;color:#567;background:#fff;box-shadow:0 0 3px rgba(0, 0, 0, 0.2)",
          formatter: function(params) {
            let html = "";
            params.forEach(v => {
              // console.log(v);
              html += `<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                color[v.componentIndex]
              };"></span>${v.seriesName}<span style="color:${
                color[v.componentIndex]
              };font-size:18px;font-weight:700">${v.value}</span>万`;
            });
            return html;
          }
        },
        legend: {
          show: true,
          x: "center",
          top: "30",
          textStyle: {
            color: fontColor
          },
          data: memberRegist.Namelegend
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              color: fontColor
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#397cbc"
              }
            },
            data: memberRegist.xAxisData
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "数量",
            axisLine: {
              lineStyle: {
                color: fontColor
              }
            }
          }
        ],
        series: [
          {
            name: memberRegist.Namelegend[0],
            symbol: "circle",
            type: "line",
            symbolSize: 8,
            data: memberRegist.referee,
            lineStyle: lineStyle(0),
            areaStyle: areaStyle(0)
          },
          {
            name: memberRegist.Namelegend[1],
            symbol: "circle",
            type: "line",
            symbolSize: 8,
            data: memberRegist.waiter,
            lineStyle: lineStyle(1),
            areaStyle: areaStyle(1)
          },
          {
            name: memberRegist.Namelegend[2],
            type: "line",
            symbol: "circle",
            symbolSize: 8,
            data: memberRegist.mpopen,
            lineStyle: lineStyle(2),
            areaStyle: areaStyle(2)
          },
          {
            name: memberRegist.Namelegend[3],
            type: "line",
            symbol: "circle",
            symbolSize: 8,
            data: memberRegist.promotion,
            lineStyle: lineStyle(3),
            areaStyle: areaStyle(3)
          }
        ]
      };
      console.log("====3222====", option);
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      console.log("===3333=====");
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/statistics/user111/part/echartone.vue